import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-nav-button',
  templateUrl: './nav-button.component.html'
})
export class NavButtonComponent {
  @Input() targetRoute: string;
  @Input() buttonTitle: string;

}
